import { render, staticRenderFns } from "./ViewNameIndicator.vue?vue&type=template&id=6c1a4155&scoped=true&"
import script from "./ViewNameIndicator.vue?vue&type=script&lang=ts&"
export * from "./ViewNameIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./ViewNameIndicator.vue?vue&type=style&index=0&id=6c1a4155&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a4155",
  null
  
)

export default component.exports